import React from 'react';
interface LogoProps {
  color?: string;
  size?: number;
  showText?: boolean;
  className?: string;
}
export function Logo({
  color = '#FFFFFF',
  size = 64,
  showText = true,
  className = ''
}: LogoProps) {
  return <div className={`flex flex-col items-center justify-center ${className}`} data-id="element-183">
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-184">
        {/* Three interlocked circles */}
        <circle cx="50" cy="35" r="25" stroke={color} strokeWidth="2" fill="none" data-id="element-185" />
        <circle cx="35" cy="60" r="25" stroke={color} strokeWidth="2" fill="none" data-id="element-186" />
        <circle cx="65" cy="60" r="25" stroke={color} strokeWidth="2" fill="none" data-id="element-187" />

        {/* Center heart */}
        <path d="M50 58C50 58 45 53 45 49.5C45 47.5 46.5 46 48.5 46C49.5 46 50 46.5 50 46.5C50 46.5 50.5 46 51.5 46C53.5 46 55 47.5 55 49.5C55 53 50 58 50 58Z" fill={color} data-id="element-188" />
      </svg>
      {showText && <div className="mt-4 text-center font-serif uppercase tracking-[0.3em] text-xs" style={{
      color
    }} data-id="element-189">
          Las Llaves de tu Alma
        </div>}
    </div>;
}